export default __webpack_public_path__ + "static/media/2.14db0127.png";